import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableCell,
  TableRow,
} from "semantic-ui-react";

const SuppNegoList = ({ suppNegoDataSet, formatter }) => {
  return (
    <div className="ui segment">
      {/* <div className="ui dividing header">Supplier Negotiation</div> */}
      <>
        {suppNegoDataSet.length > 0 ? (
          <Table celled>
            <TableHeader>
              <TableRow>
                <TableHeaderCell>Charge Type</TableHeaderCell>
                <TableHeaderCell>Amount</TableHeaderCell>
                <TableHeaderCell>Qty</TableHeaderCell>
                <TableHeaderCell>Status</TableHeaderCell>
                <TableHeaderCell>Remark</TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {suppNegoDataSet?.map((td) => (
                <TableRow>
                  <TableCell>{td?.jotTypeValue}</TableCell>
                  <TableCell>
                    {formatter
                      ? formatter.format(td?.jotCharge)
                      : td?.jotCharge}
                  </TableCell>
                  <TableCell>{td?.jotQty}</TableCell>
                  <TableCell>{td?.jotStatusValue}</TableCell>
                  <TableCell>{td?.jotDescriptionn}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div style={{ marginTop: "5px", textAlign: "center" }}>
            No Supplier Negotiation found
          </div>
        )}
      </>
    </div>
  );
};

export default SuppNegoList;
